import { API } from "@/lib/api";

// ---------------------------------------------------------------------------
// Google Ads conversion tag (native). Dormant until the three REACT_APP_GADS_*
// values are set in frontend/.env — the gtag.js library is already loaded for
// GA4, so registering the AW- ID on the same tag is all that's required.
// ---------------------------------------------------------------------------
const GADS_ID = process.env.REACT_APP_GADS_ID;
const GADS_LABEL_FORM = process.env.REACT_APP_GADS_LABEL_FORM;
const GADS_LABEL_CALL = process.env.REACT_APP_GADS_LABEL_CALL;

if (GADS_ID && typeof window !== "undefined") {
  const boot = () => window.gtag && window.gtag("config", GADS_ID);
  if (window.gtag) boot();
  else {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    boot();
  }
}

const adsConversion = (label) => {
  if (GADS_ID && label && typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: `${GADS_ID}/${label}` });
  }
};

// Fires the Google Ads "lead form submit" conversion. Called on /thank-you,
// which every successful quote/enquiry submission lands on.
export const trackLeadConversion = () => adsConversion(GADS_LABEL_FORM);

// Lightweight Google Analytics 4 event helper.
// Safe no-op if gtag isn't loaded (e.g. preview / ad-blockers).
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

// Fired when a visitor taps a phone number anywhere on the site.
// Also logs the tap server-side so the weekly recap email can count calls.
export const trackCall = (source) => {
  trackEvent("phone_call", { event_category: "engagement", source });
  adsConversion(GADS_LABEL_CALL);
  try {
    fetch(`${API}/events/call`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* non-blocking */
  }
};

// Fired on a successful quote/enquiry submission. Sends the GA4 recommended
// "generate_lead" event plus a descriptive "quote_submitted" event.
export const trackQuoteSubmit = (source) => {
  trackEvent("generate_lead", { event_category: "engagement", source });
  trackEvent("quote_submitted", { source });
};
